import React from "react";

import { nameValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function PartnerRegistrationBirthName(props: {
	labelClassName?: string;
}) {
	const { labelClassName } = props;

	return (
		<FormInputField
			id="birthName"
			className="form__field"
			name="birthName"
			label="registration:BIRTH_NAME_LABEL"
			labelClassName={labelClassName}
			placeholder="registration:BIRTH_NAME_PLACEHOLDER"
			pattern={{
				value: nameValidationPattern,
				message: "registration:INVALID_BIRTH_NAME",
			}}
			required
		/>
	);
}
